import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {AppComponent} from '../app.component';
import {cloneDeep} from "lodash";

declare var $: any;

@Component({
	selector: 'app-tutoriels',
	templateUrl: './tutoriels.component.html',
	encapsulation: ViewEncapsulation.None,
	styleUrls: ['./tutoriels.component.less']
})
export class TutorielsComponent implements OnInit {
	globalTxt: any;
	textes: any;
	videos: any = [];

	constructor(
		public app: AppComponent,
		private sanitizer: DomSanitizer
	) {
	}

	getSafeUrl(url: string): SafeResourceUrl {
		// Remove the query parameter from the URL
		const urlWithoutQueryParameter = url.split('?')[0];

		return this.sanitizer.bypassSecurityTrustResourceUrl(urlWithoutQueryParameter);
	}

	ngOnInit(): void {
		if (!this.app.sharedToolsService.getIfSessionExists()) {
			this.app.router.navigate(['/']);
			return;
		}

		// Load the nameJson and initialize the component
		this.app.dataInitService.getNameJsonReady((nameJson) => {
			this.getInfosInit(nameJson);
		});
	}

	getInfosInit(_nameJson: any) {
		// Get the texts
		this.app.sharedToolsService.loadTexts(_nameJson)
			.subscribe(textes => {
				this.textes = textes;

				// Get the videos
				this.videos = cloneDeep(textes.videos);

				if (this.videos && this.videos.length > 0) {
					this.videos.forEach((video: any) => {
						video.safeUrl = this.getSafeUrl(video.url);
					});
				}

				// Get the global texts
				this.app.dataInitService.getGlobalTextsOnce(globalTxt => {
					this.globalTxt = globalTxt;
					console.log("this.globalTxt ==> ", this.globalTxt);
				})
			})
	}
}
